import React, { useEffect, useState } from "react";
import {
    TextField,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import { startAlerta } from "../../../actions/ui/alertas";
import { AnularSolicitud } from "../../../actions/compras/Cotizaciones";



export default function ModalAnularSolicitud({ open, handleClose, idCotizacion, idTipoSolicitud,disabled,msj }) {
    const dispatch = useDispatch();
    const [texto, setTexto] = useState("");

    const handleGuardar = async () => {
        if (texto) {
            dispatch(AnularSolicitud(idCotizacion, texto, idTipoSolicitud, handleClose));

        } else {
            dispatch(startAlerta("Debe completar el motivo de anulacion", 'error', 'Error'))
        }
    };
    useEffect(()=>{
        if(disabled){
            setTexto(msj)
        }else{
            setTexto("")
        }
    },[dispatch, msj])
    return (
        <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
        <DialogTitle>Anular Solicitud</DialogTitle>
        <DialogContent dividers>
          <TextField
            fullWidth
            multiline
            rows={4}
            label="Ingrese motivo de anulación"
            variant="outlined"
            value={texto}
            onChange={(e) => setTexto(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined" disabled={disabled}>
            Cancelar
          </Button>
          <Button onClick={handleGuardar} variant="contained" color="primary" disabled={disabled}>
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
    );
}
